/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SaveChecklistRequest model module.
 * @module model/SaveChecklistRequest
 * @version V1
 */
class SaveChecklistRequest {
    /**
     * Constructs a new <code>SaveChecklistRequest</code>.
     * @alias module:model/SaveChecklistRequest
     */
    constructor() { 
        
        SaveChecklistRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SaveChecklistRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SaveChecklistRequest} obj Optional instance to populate.
     * @return {module:model/SaveChecklistRequest} The populated <code>SaveChecklistRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SaveChecklistRequest();

            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('properties')) {
                obj['properties'] = ApiClient.convertToType(data['properties'], ['String']);
            }
            if (data.hasOwnProperty('accountWide')) {
                obj['accountWide'] = ApiClient.convertToType(data['accountWide'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SaveChecklistRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SaveChecklistRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
            throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['properties'])) {
            throw new Error("Expected the field `properties` to be an array in the JSON data but got " + data['properties']);
        }

        return true;
    }


}



/**
 * @member {String} name
 */
SaveChecklistRequest.prototype['name'] = undefined;

/**
 * @member {Array.<String>} properties
 */
SaveChecklistRequest.prototype['properties'] = undefined;

/**
 * @member {Boolean} accountWide
 */
SaveChecklistRequest.prototype['accountWide'] = undefined;






export default SaveChecklistRequest;

